import { useRive } from '@rive-app/react-canvas';
import bglinesrive from '../assets/rive/bg-lines.riv';

const Consulting1 = () => {
  const { RiveComponent } = useRive({
    src: bglinesrive,
    autoplay: true,
    stateMachines: 'SM', // This will make the animation play automatically
  });

  return (
    <section className="min-h-[450px] sm:h-[700px] lg:h-[850px] bg-[#070709] relative overflow-visible -mt-[30px] sm:-mt-[50px] z-0 py-20 sm:py-0">
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 sm:top-85 sm:translate-y-0 z-50 w-full max-w-4xl px-6 sm:px-4 text-center">
        <h2 className="font-['Calsans'] font-medium text-2xl sm:text-4xl lg:text-[48px] text-white tracking-[0.02em] mb-4 sm:mb-6 leading-tight px-2">
          Zu viel Hype.<br className="sm:hidden"/> Zu wenig Strategie.
        </h2>
        <p className="font-['Geist'] font-light text-sm sm:text-base text-[#ADB0B9] max-w-2xl mx-auto pb-8 sm:pb-[54px] px-2 sm:px-0">
          Täglich entstehen neue Tools, neue Trends und neue Versprechen. Doch viele Unternehmer wissen nicht, welche davon wirklich relevant sind oder wo sie überhaupt anfangen sollen. KI kann echte Ergebnisse liefern, wenn man weiß, wie man sie richtig einsetzt.
        </p>
      </div>
      {/* Radial Gradient Blur - Responsive */}
      {/*<div
        aria-hidden="true"
        className="pointer-events-none absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 sm:top-50 sm:-translate-y-[40%] -z-10 w-[120%] h-[80vh] sm:size-[466px] md:size-[596px] lg:size-[850px] xl:size-[1000px] rounded-full bg-[radial-gradient(50%_50%_at_50%_50%,rgba(16,17,20,0.75),transparent)]"
      />*/}
      {/* Gradient Overlay for smooth transition to next section */}
      {/*<div className="absolute bottom-0 left-0 w-full h-64 z-20" style={{
        background: 'linear-gradient(to top, #030304 0%, #03030433 50%, #03030400 100%)',
        WebkitBackdropFilter: 'blur(0.5px)',
        backdropFilter: 'blur(0.5px)',
        WebkitOptimizeContrast: 'auto',
        imageRendering: 'optimizeQuality',
      }}></div>*/}
      {/* Gradient Overlay */}
      {/*<div className="absolute top-0 left-0 w-full h-32 z-20 pointer-events-none" style={{
        background: 'linear-gradient(to bottom, #070709 0%, #07070933 50%, #07070900 100%)',
        WebkitBackdropFilter: 'blur(0.5px)',
        backdropFilter: 'blur(0.5px)',
        WebkitOptimizeContrast: 'auto',
        imageRendering: 'optimizeQuality',
      }}></div>*/}
      {/* Background Elements - Responsive */}
      <div className="absolute left-1/2 -top-10 sm:-top-25 z-10 w-full max-w-[1200px] -translate-x-1/2 px-4">
        {/* Container that maintains aspect ratio */}
        <div className="relative w-full" style={{ paddingBottom: '75%' }}>
          {/* Rive Animation with Gradient Overlay */}
          <div className="absolute inset-0 flex items-center justify-center mt-10">
            <div className="relative w-full h-full max-w-[900px]">
              <RiveComponent 
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  position: 'relative',
                  zIndex: 1
                }} 
              />
              <div 
                className="absolute left-0 right-0 z-10 pointer-events-none"
                style={{
                  background: 'linear-gradient(to bottom, rgba(7, 7, 9, 0.10) 0%, rgba(7, 7, 9, 0.99) 50%, #070709 100%)',
                  height: '250px',
                  top: '47%',
                  transform: 'translateY(-50%)',
                  mixBlendMode: 'multiply'
                }}
                aria-hidden="true"
              />
            </div>
          </div>
        </div>
        
        {/* Gradient Blur */}
        {/*<div className="absolute top-0 left-0 w-full">
          <div className="h-[120px] w-full -translate-y-[75%] rounded-[100%] bg-gradient-to-b from-black via-black via-[90%] to-transparent blur-[36px] lg:-translate-y-1/2 md:h-[100px] md:-translate-y-[53%] md:blur-xl sm:h-20"></div>
        </div>*/}
        
        {/* Noise overlay */}
        <div className="noise absolute inset-0 z-0 opacity-5 mix-blend-soft-light" aria-hidden="true"></div>
        
        {/* Center line */}
        <span className="absolute left-1/2 top-0 -z-10 h-full w-px" aria-hidden="true"></span>
      </div>
    </section>
  );
};

export default Consulting1;
